import { Button, CircularProgress, Grid } from "@mui/material";
type Props = {
  isSubmitLoading: boolean;
  onHide: (proceed: boolean) => void;
  buttonColor?: "inherit" | "primary" | "secondary" | undefined;
  buttonLabel?: "Delete" | "Save";
  disabled?: boolean;
  className?: string;
};
export const FooterModalButtons = ({
  isSubmitLoading,
  onHide,
  buttonColor = "primary",
  buttonLabel = "Save",
  disabled = false,
  className,
}: Props) => {
  return (
    <Grid container spacing={2} justifyContent="flex-end">
      <Grid item md={3} xs={12} style={{ margin: 0 }}>
        <Button
          fullWidth
          variant="contained"
          color="inherit"
          onClick={() => onHide(false)}
          className={className}
        >
          Cancel
        </Button>
      </Grid>
      <Grid item md={3} xs={12} style={{ margin: 0 }}>
        <Button
          fullWidth
          startIcon={isSubmitLoading && <CircularProgress size="1rem" />}
          disabled={isSubmitLoading || disabled}
          variant="contained"
          color={buttonColor}
          type="submit"
          className={className}
        >
          {buttonLabel}
        </Button>
      </Grid>
    </Grid>
  );
};
